import { Box } from '@mui/material';
import { FC } from 'react';
import { ReferenceManyField } from 'react-admin';

import { GetB2bContractsIdEndpoint } from '@Common/types/bo/b2b/contracts';
import { GetBoInvestorProfilesEndpoint } from '@Common/types/bo/b2b/investor_profile';
import { GetBoExternalContractsOneResponse } from '@Common/types/bo_external/contracts';

import { DatagridTyped, EmptyScreen, Pagination } from '@sh4res/bo-common/components';
import { EmptyPartySvg } from '@sh4res/bo-common/graphics';
import { useResourceBasePath } from '@sh4res/bo-common/hooks';
import { B2bInvestorProfileCreate } from '@sh4res/bo-common/resources/investor_profile/B2bInvestorProfileCreate';
import {
  b2bInvestorProfileDefaultColumns,
  createB2bInvestorProfileListColumns,
} from '@sh4res/bo-common/resources/investor_profile/B2bInvestorProfileList';
import { getB2BInvestorProfileResourceReference } from '@sh4res/bo-common/resources/investor_profile/helpers/getB2BInvestorProfileResourceReference';
import { isBoExternal } from '@sh4res/bo-common/utils/env';

type Props = {
  record: GetBoExternalContractsOneResponse | GetB2bContractsIdEndpoint['Client']['ResponseBody'];
};

export const B2BInvestorProfileVerticalTabContent: FC<Props> = (props) => {
  const { record } = props;

  const resourceBasePath = useResourceBasePath();
  const b2bInvestorProfileListColumns = createB2bInvestorProfileListColumns(resourceBasePath);

  return (
    <ReferenceManyField
      reference={getB2BInvestorProfileResourceReference(resourceBasePath)}
      filter={{ b2b_company_id: record.b2b_company_id, b2b_contract_id: record.id }}
      target="b2b_contract_id"
      perPage={10}
      data-testid="BoExternalB2BInvestorProfileVerticalTabContent_ReferenceManyField"
      sort={{ field: 'id', order: 'ASC' }}
      pagination={<Pagination handleFloatingButton={true} />}>
      <Box sx={{ paddingTop: '3px', paddingBottom: '3px' }}>
        <DatagridTyped<GetBoInvestorProfilesEndpoint['Client']['ResponseBody'][number]>
          sortableColumns={[]}
          columnRegistry={b2bInvestorProfileListColumns}
          displayedColumns={b2bInvestorProfileDefaultColumns}
          bulkActionButtons={false}
          showCard={true}
          rowClick="show"
          empty={
            <EmptyScreen
              svg={<EmptyPartySvg />}
              button={
                !isBoExternal() && (
                  <B2bInvestorProfileCreate
                    size="medium"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    companyId={record.b2b_company_id}
                    contractId={record.id}
                    testId="BoExternalB2BInvestorProfileVerticalTabContentInvestorProfileCreate"
                  />
                )
              }
              label="resources.bo_common.b2b.investor_profile.list.empty"
            />
          }
        />
      </Box>
    </ReferenceManyField>
  );
};
